import React from 'lib/react';
import { EVSkeleton } from 'lib/components';

function ChartsLoader() {
  return (
    <>
      <EVSkeleton variant="rect" height="100%" style={{ flex: 3, minHeight: '200px' }} />
      <EVSkeleton variant="rect" height="100%" style={{ flex: 1, minHeight: '200px' }} />
    </>
  );
}

export default ChartsLoader;
